import { render, staticRenderFns } from "./smtpMailView.vue?vue&type=template&id=6e70f69c&scoped=true"
import script from "./smtpMailView.vue?vue&type=script&lang=js"
export * from "./smtpMailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e70f69c",
  null
  
)

export default component.exports